import { Injectable } from '@angular/core';
import { environment } from '@env/insitestore360';

@Injectable({
    providedIn: 'root'
})
export class FirebaseService {
    private initialized = false;

    async initializeFirebase() {
        if (typeof window !== 'undefined' && !this.initialized) {
            try {
                const { initializeApp } = await import('firebase/app');
                initializeApp(environment.firebaseConfig);
                this.initialized = true;
            } catch (error) {
                console.error('Failed to initialize Firebase:', error);
            }
        }
    }
}